import { useSelector, useDispatch } from 'react-redux';
import Radio from '@mui/material/Radio';
import { setSelected } from '../../../../../Redux/slices/globalSlice';

export default function PatientSelect({row}) {
    const dispatch = useDispatch();
    const { selected } = useSelector((state) => ({
        selected: state.setting.selected,
    }));
    const onChangeSelected = (e) => {
        dispatch(setSelected(e.target.value))
    }
    return (
        <Radio
          checked={row.id === selected}
          onChange={onChangeSelected}
          value={row.id}
          name="patient-radio-buttons"
        />
    );
}